import { useTranslation } from 'react-i18next';
import { useBuilderContext } from '../../context/BuilderContext';

export function ParticipantsSection() {
  const { t } = useTranslation();
  const { form, setForm } = useBuilderContext();

  return (
    <div className="builder-section">
      <div className="cfg-section-head">
        <div>
          <h3><i className="fas fa-users" /> {t('admin.builderParticipantsTitle')}</h3>
          <p className="cfg-section-sub">{t('admin.builderParticipantsSub')}</p>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
        <div className="form-group" style={{ flex: 1, minWidth: 140 }}>
          <label className="cfg-label">{t('admin.builderMinParticipantsLabel')}</label>
          <input
            type="number"
            className="form-input"
            min={1}
            max={20}
            value={form.minRespondents}
            onChange={e => setForm(p => ({ ...p, minRespondents: parseInt(e.target.value) || 1 }))}
          />
          <small style={{ color: '#888', fontSize: '0.72rem' }}>{t('admin.builderMinParticipantsHint')}</small>
        </div>
        <div className="form-group" style={{ flex: 1, minWidth: 140 }}>
          <label className="cfg-label">{t('admin.builderMaxParticipantsLabel')}</label>
          <input
            type="number"
            className="form-input"
            min={1}
            max={30}
            value={form.maxRespondents}
            onChange={e => setForm(p => ({ ...p, maxRespondents: parseInt(e.target.value) || 1 }))}
          />
          <small style={{ color: '#888', fontSize: '0.72rem' }}>{t('admin.builderMaxParticipantsHint')}</small>
        </div>
      </div>
    </div>
  );
}
